import styles from './WrapperDetailsMessage.module.scss';
import { IWrapperDetailsMessageProps } from '../../types';
import { Text, TextColor, TextSize, TextWeight } from '@components/Text';

const WrapperDetailsMessage: React.FC<IWrapperDetailsMessageProps> = (props: IWrapperDetailsMessageProps): React.ReactElement => {
  const { description, title } = props;

  return (
      <div className={styles.message}>
        <Text
            color={TextColor.PRIMARY}
            size={TextSize.S}
            weight={TextWeight.BOLD}
        >
          {title}
        </Text>
        <Text
            color={TextColor.PRIMARY}
            size={TextSize.S}
            weight={TextWeight.NORMAL}
        >
          {description}
        </Text>
      </div>
  );
};

export default WrapperDetailsMessage;